import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class KPIProduitsService {
  getFamilleOrSousFamilleOrCategoriesOrMarques(idUser, month, year, type) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getByTypeFamilleOrSousFamilleOrCategoriesOrMarques/" +
      idUser +
      "/" +
      month +
      "/" +
      year,
      {
        params: {
          type: type,
        },
      }
    );
  }

  getTopThreeFamilleAndSousFamilleAndCategoriesAndMarquesAndPack(
    idUser,
    month,
    year
  ) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getTopThreeFamilleAndSousFamilleAndCategoriesAndMarquesAndPack/" +
      idUser +
      "/" +
      month +
      "/" +
      year
    );
  }

  getProductsByCategorie(
    idUser,
    month,
    year,
    idCategorie,
    skuCategorie,
    calendarFilter,
    typeToFilter,
    type
  ) {
    return api.get(
      UtilsUrl.KpiSaleURL() + "/getProductsByCategorie/" + idUser,
      {
        params: {
          type: type,
          month: month,
          year: year,
          idCategorie: idCategorie,
          skuCategorie: skuCategorie,
          calendarFilter: calendarFilter,
          typeToFilter: typeToFilter,
        },
      }
    );
  }

  getProductsByPack(idUser, month, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getProductsByPack/" +
      idUser +
      "/" +
      month +
      "/" +
      year
    );
  }

  getProductsByDevisAndYear(idUser, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getProductsByDevisAndYear/" +
      idUser +
      "/" +
      year
    );
  }

  getProductsByDevis(idUser, month, year) {
    return api.get(
      UtilsUrl.KpiSaleURL() +
      "/getProductsByDevis/" +
      idUser +
      "/" +
      month +
      "/" +
      year
    );
  }
}

export default new KPIProduitsService();
